import {
  CABIN_BAG_KEBAB_CASE,
  CHECKED_BAG_KEBAB_CASE,
} from '@web-platform/shared-universal-constants/src/queryParamMapper';
import { FARE_ATTRIBUTES } from '@web-platform/shared-universal-constants/src/queryParams';
import { parseParams } from '@web-platform/shared-universal-utils-frontend/src/helpers/queryParams/parseParams';

import { INITIAL_STATE } from '../baggage';

import type { BaggageFilterState } from '@web-platform/shared-universal-types/src/redux/state/flightSearchResults/features/filters/baggage';

export const getBaggageFromUrl = (): BaggageFilterState => {
  const fareAttributes = parseParams()[FARE_ATTRIBUTES];
  if (!fareAttributes) return INITIAL_STATE;
  const tokens = new Set(
    fareAttributes
      .toLowerCase()
      .split(',')
      .map((token: string) => token.trim()),
  );
  return {
    cabinBag: tokens.has(CABIN_BAG_KEBAB_CASE),
    checkedBag: tokens.has(CHECKED_BAG_KEBAB_CASE),
  };
};
